import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const textareaVariants = cva(
  cn(
    'flex min-h-[60px] w-full px-4 py-4 text-sm lg:text-base shadow-none placeholder:text-[#9E9E9E]',
    'focus-visible:outline-none',
  ),
  {
    variants: {
      variant: {
        outlined: ['bg-white border border-border', 'ea-textarea__outlined'],
        filled: ['bg-input', 'ea-textarea__filled'],
      },
      rounded: {
        default: 'rounded-[12px]',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      rounded: 'default',
      variant: 'filled',
    },
  },
);

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants> & {
    className?: string;
    classNames?: string;
    floatingLabel?: boolean;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, classNames, floatingLabel, ...props }, ref) => {
    return (
      <textarea
        style={{ resize: 'none' }}
        className={cn(
          textareaVariants({
            variant: props.variant,
            rounded: props.rounded,
            className: cn(
              'ea-textarea bg-[#F5F5F5]',
              props['aria-invalid'] && 'ea-textarea--invalid border-destructive text-destructive',
              className,
              classNames,
            ),
          }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
